import { keys } from "@/lib/i18n/portal";
import type { ThemeStatus } from "@/lib/api/types";

export const THEME_STATUS_LABEL_KEY: Record<ThemeStatus, string> = {
  DRAFT: keys.themes.draft,
  PUBLISHED: keys.themes.published,
  ARCHIVED: keys.themes.archived,
};
